import { FC } from 'react'
import { Navigate } from 'react-router-dom'

import LatestMessagesPage from '@/apps/latest/pages/messages'
import { useLineSettingsQuery } from '@/features/internal/patient-messaging'
import { useAppType } from '@/shared/contexts/AppTypeContext'
import { isLegacyApp } from '@/types/appType'

// 患者との LINE のやり取りは latest shell の面。legacy は凍結シェルのため導線も画面も持たない。
// LINE 連携の設定が済んでいない店舗には IconBar に項目を出さないので、URL 直打ちもホームへ返す
// (nav の gate と route の gate を一致させる)。読込中は判定を保留する。
const MessagesPage: FC = () => {
  const { appType, isLoading } = useAppType()
  const { data: settings, isLoading: isSettingsLoading } =
    useLineSettingsQuery()

  if (isLoading || isSettingsLoading) return null
  if (isLegacyApp(appType) || !settings?.is_configured) {
    return <Navigate to="/" replace />
  }
  return <LatestMessagesPage />
}

export default MessagesPage
